import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    id: 1,
    name: 'María González',
    age: 34,
    city: 'Buenos Aires',
    country: 'Argentina',
    text: 'No podía creer lo fácil que es hacer un glaseado profesional. Mis budines ahora parecen de pastelería.',
    initials: 'MG'
  }, {
    id: 2,
    name: 'Carolina Méndez',
    age: 28,
    city: 'Bogotá',
    country: 'Colombia',
    text: 'Las recetas son súper claras y con ingredientes que tengo en casa. ¡Ya probé 10 coberturas!',
    initials: 'CM'
  }, {
    id: 3,
    name: 'Laura Fernández',
    age: 41,
    city: 'Ciudad de México',
    country: 'México',
    text: 'Empecé a vender budines con estas coberturas y mis clientes no paran de pedirme más.',
    initials: 'LF'
  }, {
    id: 4,
    name: 'Patricia Rojas',
    age: 36,
    city: 'Santiago',
    country: 'Chile',
    text: 'La guía de budines salados fue una sorpresa increíble. Ahora hago budines para toda ocasión.',
    initials: 'PR'
  }, {
    id: 5,
    name: 'Ana Martínez',
    age: 45,
    city: 'Madrid',
    country: 'España',
    text: 'Llevaba años haciendo budines simples. Con este libro descubrí un mundo nuevo de sabores.',
    initials: 'AM'
  }];
  return <section className="py-24 bg-[#F5EDE3] text-[#3D2B1F] px-4 border-y border-[#3D2B1F]/10" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <div className="text-center mb-16" data-id="element-186">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#3D2B1F] to-[#6B5344]" data-id="element-187">
            Lo que dicen quienes ya lo probaron
          </motion.h2>
          <div className="flex justify-center gap-1" data-id="element-188">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 fill-[#C67B30] text-[#C67B30]" data-id="element-189" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl border border-[#3D2B1F]/10 relative group hover:border-[#C67B30]/30 transition-colors duration-300 shadow-lg" data-id="element-191">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-[#3D2B1F]/5 group-hover:text-[#C67B30]/10 transition-colors" data-id="element-192" />

              <div className="flex gap-1 mb-6" data-id="element-193">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#C67B30] text-[#C67B30]" data-id="element-194" />)}
              </div>

              <p className="text-[#6B5344] text-lg italic mb-8 leading-relaxed" data-id="element-195">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-196">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#C67B30] to-[#D4943A] flex items-center justify-center text-white font-black text-xl shadow-lg" data-id="element-197">
                  {testimonial.initials}
                </div>
                <div data-id="element-198">
                  <h4 className="font-bold text-[#3D2B1F] text-lg" data-id="element-199">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-[#9C8578]" data-id="element-200">
                    {testimonial.age} años • {testimonial.city},{' '}
                    {testimonial.country}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}